<script setup>
import { reactiveOmit } from '@vueuse/core';
import { DatePickerInput, useForwardProps } from 'reka-ui';
import { cn } from '@/lib/utils';

const props = defineProps({
    part: { type: String, required: true },
    asChild: { type: Boolean, required: false },
    as: { type: null, required: false },
    class: { type: null, required: false },
});

const delegatedProps = reactiveOmit(props, 'class');

const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
    <DatePickerInput
        :class="
            cn(
                'data-[placeholder]:text-muted-foreground inline-flex items-center justify-center rounded-sm px-0.5 tabular-nums caret-transparent outline-none focus:bg-accent focus:text-white',
                props.class,
            )
        "
        v-bind="forwardedProps"
    >
        <slot />
    </DatePickerInput>
</template>
